import { RoleService } from './../user/services/role.service';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../user/services/user.service';
import { Role } from '../user/models/role.model';
import { RoleConstant } from '../user/constants/role.constant';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class IsSysAdminGuard implements CanActivate {
  /**
   *
   */
  constructor(private roleService: RoleService) {


  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const currentPath = next.routeConfig?.path;
    return this.roleService.getByUserRoles().pipe(map((response: string[]) => {
      const isSysAdmin = response.includes(RoleConstant.sysAdmin);
      if (isSysAdmin) {
        return true;
      }
      if (currentPath === 'region') {
        return true;
      }
      return false;
    }));
  }

}
